// extracted by mini-css-extract-plugin
module.exports = {"captchaGroup":"captchaGroup___1tuoT","largeCaptcha":"largeCaptcha___36ipG","imgcode":"imgcode___WbcDU"};